<template>
  <header class="mobile-topbar">
    <button
      type="button"
      class="mobile-topbar__menu"
      :aria-label="t('mobileNav.openMenu')"
      :aria-expanded="mobileNav.isDrawerOpen"
      @click="mobileNav.toggleDrawer()"
    >
      <BurgerIcon />
    </button>

    <h1 class="mobile-topbar__title">{{ currentTitle }}</h1>

    <!-- Кнопки раздела приходят сюда телепортом: на телефоне место в шапке
         одно, а рисуют их страницы. Слот оставлен для прямых потребителей. -->
    <div
      id="mobile-topbar-actions"
      class="mobile-topbar__actions"
    >
      <slot name="actions" />
    </div>
  </header>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useMobileNavStore } from "../store/mobileNav";
import { useMobileNavigation } from "../common/composables/useMobileNavigation";
import BurgerIcon from "../assets/icons/BurgerIcon.vue";

const { t } = useI18n();
const mobileNav = useMobileNavStore();
const { currentTitle } = useMobileNavigation();
</script>
